/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_TypeInputs */

const en_group_type = /** @type {(inputs: Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Type`)
};

const fr_group_type = /** @type {(inputs: Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de groupe`)
};

const de_group_type = /** @type {(inputs: Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppentyp`)
};

const it_group_type = /** @type {(inputs: Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di gruppo`)
};

const ru_group_type = /** @type {(inputs: Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип группы`)
};

const es_group_type = /** @type {(inputs: Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de grupo`)
};

const zh_cn2_group_type = /** @type {(inputs: Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组类型`)
};

const ja_group_type = /** @type {(inputs: Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループタイプ`)
};

const hi_group_type = /** @type {(inputs: Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह प्रकार`)
};

const pt_pt2_group_type = /** @type {(inputs: Group_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de grupo`)
};

/**
* | output |
* | --- |
* | "Group Type" |
*
* @param {Group_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const group_type = /** @type {((inputs?: Group_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_group_type(inputs)
	if (locale === "de") return de_group_type(inputs)
	if (locale === "it") return it_group_type(inputs)
	if (locale === "ru") return ru_group_type(inputs)
	if (locale === "es") return es_group_type(inputs)
	if (locale === "zh-CN") return zh_cn2_group_type(inputs)
	if (locale === "ja") return ja_group_type(inputs)
	if (locale === "hi") return hi_group_type(inputs)
	if (locale === "pt-PT") return pt_pt2_group_type(inputs)
	return en_group_type(inputs)
});